import { createContext, useContext } from "react";
export function factoryLanguageContext(req) {
  return {
    language: req.language,
    translations: req.translations
  };
}
var LanguageContext = /*#__PURE__*/createContext({
  language: "en",
  translations: {}
});
export var useLang = function useLang() {
  if (__IS_CSR__) {
    return window.language;
  }
  return useContext(LanguageContext).language;
};
export var useGetTranslations = function useGetTranslations() {
  if (__IS_CSR__) {
    return window.translations;
  }
  return useContext(LanguageContext).translations;
};
export default LanguageContext;